import { Module } from "vuex"
import { GamesState, RootState } from "@/store/types"
import { createAsyncAction } from "../utils/createAsyncAction"
import { getGames } from "../api"

const gamesStore: Module<GamesState, RootState> = {
  namespaced: true,
  state: () => ({
    data: [],
    loading: true,
  }),
  getters: {
    data: (state) => state,
  },
  mutations: {
    SET_ASYNC_STATE<K extends keyof GamesState>(
      state: GamesState,
      {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        key,
        patch,
      }: {
        key: K
        patch: Partial<GamesState[K]>
      }
    ) {
      Object.assign(state, patch)
    },
  },
  actions: {
    getGames: createAsyncAction(getGames, "games"),
  },
}

export default gamesStore
